import './PanelSettings.scss';

export { default } from './PanelSettings';
